import { render, staticRenderFns } from "./PostLikeCounter.vue?vue&type=template&id=778f08c4&scoped=true&"
import script from "./PostLikeCounter.vue?vue&type=script&lang=js&"
export * from "./PostLikeCounter.vue?vue&type=script&lang=js&"
import style0 from "./PostLikeCounter.vue?vue&type=style&index=0&id=778f08c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778f08c4",
  null
  
)

export default component.exports